export default __webpack_public_path__ + "static/media/5048.6b8becda.png";